import { ClickCommandType, SelectStepBehaviorEndToken } from "sequential-workflow-designer";

// The library has no first-class "double click" option, but it exposes the
// exact primitive its own Pro package builds double-click on top of: the
// click-behavior-wrapper extension point plus SelectStepBehaviorEndToken,
// which already carries the previously-clicked step id and a timestamp.
// Wrapping a step's select behavior lets us compare the incoming click
// against that previous end token and detect a same-step double click
// without touching the DOM.
const DEFAULT_DOUBLE_CLICK_TIME_MS = 800;

export function createDoubleClickExtension(
  onStepDoubleClicked,
  doubleClickTimeMs = DEFAULT_DOUBLE_CLICK_TIME_MS,
) {
  return {
    create(_customActionController) {
      return {
        wrap(behavior, commandOrNull) {
          if (commandOrNull?.type !== ClickCommandType.selectStep) {
            return behavior;
          }

          const { step, parentSequence } = commandOrNull.component;

          return {
            onStart: (position) => behavior.onStart(position),
            onMove: (delta) => behavior.onMove(delta),
            onEnd(interrupt, element, previousEndToken) {
              const isDoubleClick =
                !interrupt &&
                SelectStepBehaviorEndToken.is(previousEndToken) &&
                previousEndToken.stepId === step.id &&
                previousEndToken.time + doubleClickTimeMs > Date.now();

              if (isDoubleClick) {
                onStepDoubleClicked(step, parentSequence);
                return;
              }

              return behavior.onEnd(interrupt, element, previousEndToken);
            },
          };
        },
      };
    },
  };
}
